import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter, Link } from 'react-router-dom';

import { Row, Col, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, Form, FormGroup, Alert, Media, Spinner } from 'reactstrap';

import { connect } from 'react-redux';

import ReactTooltip from 'react-tooltip';

import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import 'react-widgets/dist/css/react-widgets.css';

import {
  updateLastActive,
  sendOutreachEmails,
  getCompanyOutreachEmailsSentCount,
  createCompanySubscription,
} from '../../../actions/company';

import {
  getNewOutreachTooltips,
} from '../../../actions/contentManagement';

import formattedNumber from '../../components/FormattedNumber/FormattedNumber';

import defaultPrimary from '../../../assets/images/defaultPrimary.png';
import defaultLogo from '../../../assets/images/defaultLogo.png';

const pound = `${'\u00A3'}`;

function validateEmail(email) {

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isValid = emailRegex.test(email);

  return isValid;
}

class NewOutreach extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    admin: PropTypes.shape(),
    company: PropTypes.shape(),
    dashboardTooltips: PropTypes.shape(),
    fetchNewOutreachTooltips: PropTypes.func.isRequired,
    fetchNewVoucherPageData: PropTypes.func.isRequired,
    fetchCompanyOutreachEmailsSentCount: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    admin: {},
    dashboardTooltips: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      discount: {},
      availableVouchers: {},
      showNoPermission: false,
      permissionLevel: null,
      dontShowPage: false,
      acceptRules: false,
      recomendedDiscounts: false,
      testMode: false,
      claimBy: new Date(Date.now() + (1000 * 60 * 60 * 24 * 30)),
      redeemBy: new Date(Date.now() + (1000 * 60 * 60 * 24 * 30)),
      expiry: '5',
      emailsList: [],
    };
  }

  componentDidMount() {
    const { user, history, adminViewAsCompany, fetchNewOutreachTooltips, updateLastActiveFunc, fetchCompanyOutreachEmailsSentCount } = this.props;

    const date = new Date();

    date.setUTCHours(0, 0, 0, 0);

    this.setState({ startDate: date, endDate: date });

    if (user && Object.keys(user).length > 0) {
      fetchNewOutreachTooltips();

      if (user.company) {
        updateLastActiveFunc(user.company);
        fetchCompanyOutreachEmailsSentCount(user.company);
      } else if (adminViewAsCompany) {
        fetchCompanyOutreachEmailsSentCount(adminViewAsCompany);
      }
      
      if (user.company) {

        if (user.role === 'teamOwner') {
          this.setState({ showNoPermission: false, dontShowPage: false, permissionLevel: null });
        } else {
          const { roles } = this.props;

          if (roles && roles[user.role] && roles[user.role].permissions && roles[user.role].permissions.createNewVoucher) {
            if (roles[user.role].permissions.createNewVoucher === 2) {
              this.setState({ showNoPermission: false, dontShowPage: false });
            } else {
              this.setState({ showNoPermission: true, dontShowPage: false });
            }
          } else {
            this.setState({ showNoPermission: true, dontShowPage: true, permissionLevel: null });
          }
        }
      } else if (adminViewAsCompany && user.roleClass === 'admin') {
        const { adminsRoles } = this.props;

        if (user.role === 'admin') {
          this.setState({ showNoPermission: false, dontShowPage: false });
        } else {
          if (adminsRoles && adminsRoles[user.role] && adminsRoles[user.role].permissions && adminsRoles[user.role].permissions.companyAccess && adminsRoles[user.role].permissions.companyAccessCreateNewVoucher) {
            if (adminsRoles[user.role].permissions.companyAccessCreateNewVoucher === 2) {
              this.setState({ showNoPermission: false, dontShowPage: false });
            } else {
              this.setState({ showNoPermission: true, dontShowPage: false });
            }
          } else {
            this.setState({ showNoPermission: true, dontShowPage: true });
          }
        }
      } else {
        history.push('/');
        return null;
      }
    } else {
      history.push('/');
    }
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value, success: false, error: false });

  handleChangeValue = e => {
    this.setState({ [e.target.name]: parseFloat(e.target.value.replace(/,/g, '')), success: false, error: false })
  };

  handleChangeRecipients = e => {
    const recipients = e.target.value;

    const emails = recipients.split(/[\n,]+/);

    const validEmails = [];

    emails.map((email) => {
      console.log('email', email, validateEmail(email));
      if (email && validateEmail(email)) {
        validEmails.push(email);
      }
    });

    console.log('validEmails', validEmails);

    this.setState({ [e.target.name]: recipients, validEmailsList: validEmails, emailsList: emails, success: false, error: false })
  };

  handleChangeIncludeLink = (e) => {
    this.setState((prevState) => ({ includeLink: !prevState.includeLink }))
  }

  handleChangePermission = (e) => {
    this.setState((prevState) => ({ permission: !prevState.permission }))
  }

  toggleReadMore = () => {
    this.setState((prevState) => ({ readMore: !prevState.readMore }))
  }

  sendEmails = () => {
    const { name, recipients, value, content, includeLink, subject, redeemBy, claimBy, permission, emailsList, validEmailsList } = this.state;
    const { fetchCompanyOutreachEmailsSentCount, user, adminViewAsCompany, sendEmails } = this.props;

    console.log('emailsList', emailsList, validEmailsList);

    if (!emailsList || !emailsList.length || validEmailsList.length !== emailsList.length) {
      this.setState({ error: "Please check the email addresses are correctly entered", success: null });
      return null;
    }

    if (!name || !recipients || !value || !content || !subject || !redeemBy || !claimBy) {
      this.setState({ error: "You've missed an input", success: null });
      return null;
    }

    if (value < 1 || value > 500) {
      this.setState({ error: `Value must be between ${pound}1 and ${pound}500`, success: null });
      return null;
    }

    if (!permission) {
      this.setState({ error: 'Please certify you have permission to send these emails', success: null });
      return null;
    }

    console.log('sendEmailssendEmails', redeemBy, claimBy);

    const claimByParsed = Date.parse(claimBy);
    const redeemByParsed = Date.parse(redeemBy);

    this.setState({ sendSpinner: true });

    sendEmails({ name, recipients, value, content, subject, includeLink, redeemBy: redeemByParsed, claimBy: claimByParsed }).then((res) => {
      if (res && res.status && res.status === 'success') {
        this.setState({
          sendSpinner: false, success: true, error: null, name: null, recipients: null, validEmailsList: null, emailsList: null, value: null, content: null, includeLink: null, subject: null, redeemBy: new Date(Date.now() + (1000 * 60 * 60 * 24 * 30)), claimBy: new Date(Date.now() + (1000 * 60 * 60 * 24 * 30)), permission: null,
        });


        if (user.company) {
          fetchCompanyOutreachEmailsSentCount(user.company);
        } else if (adminViewAsCompany) {
          fetchCompanyOutreachEmailsSentCount(adminViewAsCompany);
        }
      } else {
        this.setState({ sendSpinner: false, success: false, error: res.error || 'Failed to send vouchReach emails' });
      }
    }).catch((err) => {
      this.setState({ sendSpinner: false });
    });
  }

  changeSubscription = () => {
    const { createSubscription, adminViewAsCompany, user } = this.props;

    console.log('changeSubscription', adminViewAsCompany);

    if (adminViewAsCompany) {
      createSubscription(adminViewAsCompany, 'starter', 'month').then((res) => {
        const { sesionData } = res;

        if (sesionData && sesionData.url) {
          window.location.replace(sesionData.url);
        }
      });
    } else {
      createSubscription(user.company, 'starter', 'month').then((res) => {
        const { sesionData } = res;

        if (sesionData && sesionData.url) {
          window.location.replace(sesionData.url);
        }
      });
    }
  }

  goToManagePlan = () => {
    const { history } = this.props;

    history.push('/subscriptions');
  }

  changeClaimByDate = (date) => {
    const { redeemBy } = this.state;
    date.setUTCHours(0, 0, 0, 0);

    let today;

    if (date < new Date(Date.now())) {
      today = new Date(Date.now());

      today.setUTCHours(0, 0, 0, 0);

      date = new Date(today);

      date.setUTCHours(0, 0, 0, 0);
    }

    this.setState({ claimBy: date });

    if (date > redeemBy) {
      this.setState({ redeemBy: date });
    }
  }

  changeRedeemByDate = (date) => {
    const { claimBy } = this.state;
    date.setUTCHours(0, 0, 0, 0);

    let today;

    if (date < new Date(Date.now())) {
      today = new Date(Date.now());

      today.setUTCHours(0, 0, 0, 0);

      date = new Date(today);

      date.setUTCHours(0, 0, 0, 0);
    }

    this.setState({ redeemBy: date });

    if (date < claimBy) {
      this.setState({ claimBy: date });
    }
  }

  render() {
    const { company, dashboardTooltips, companyOutreachCount } = this.props;
    const {
      availableVouchers,
      discount,
      showNoPermission,
      dontShowPage,
      error,
      success,
      previewStep,
      expiry,
      processing,
      selectedVoucher,
      permission,

      name,
      recipients,
      value,
      content,
      subject,
      includeLink,

      emailsList,
      sendSpinner,

      claimBy,
      redeemBy,
    } = this.state;

    let amount;
    let amountInit;

    console.log('claimBy', claimBy, new Date(claimBy), Date.parse(claimBy));

    if ((selectedVoucher || selectedVoucher === 0) && (previewStep || previewStep === 0)) {
      const price = Number(availableVouchers[selectedVoucher]).toFixed(2);
      const discountVal = discount[previewStep];

      amountInit = ((price * 100) - Math.round((price * 100) * (discountVal / 100)));

      if (amountInit) {
        amount = (amountInit / 100).toFixed(2);
      }

    }

    console.log('companyOutreachCount', companyOutreachCount);

    let limit = 5;

    if (company && !company.subscriptionActive) {
      limit = 2;
    } else if (company.subscriptionActive && company.subcriptionType === 'starter') {
      limit = 100;
    } else if (company.subscriptionActive && company.subcriptionType === 'growth') {
      limit = 2000;
    } else if (company.subscriptionActive && company.subcriptionType === 'pro') {
      limit = 10000;
    } else if (company.subscriptionActive && company.subcriptionType === 'enterprise') {
      limit = 50000;
    }

    console.log('limit', limit, emailsList);

    if (dontShowPage) {
      return (
        <div>
          <Card style={{ borderRadius: 20 }}>
            <CardBody>
              You don't have permissions to create new vouchers
            </CardBody>
          </Card>
        </div>
      );
    }

    return (
      <Row style={{ margin: 0 }}>
        <Col className="card" style={{ background: '#FFF', minWidth: 420, width: 420, maxWidth: 450, height: 'fit-content', paddingRight: 22, paddingBottom: 10, borderRadius: 20 }}>
          <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='content'>
            <span>{dashboardTooltips.emailContent ? dashboardTooltips.emailContent.value : ''}</span>
          </ReactTooltip>
          <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='subject'>
            <span>{dashboardTooltips.emailSubject ? dashboardTooltips.emailSubject.value : ''}</span>
          </ReactTooltip>
          <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='name'>
            <span>{dashboardTooltips.outreachName ? dashboardTooltips.outreachName.value : ''}</span>
          </ReactTooltip>
          <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='recipients'>
            <span>{dashboardTooltips.recipientEmails ? dashboardTooltips.recipientEmails.value : ''}</span>
          </ReactTooltip>
          <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='value'>
            <span>{dashboardTooltips.voucherValue ? dashboardTooltips.voucherValue.value : ''}</span>
          </ReactTooltip>
          <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='claimBy'>
            <span>{dashboardTooltips.claimBy ? dashboardTooltips.claimBy.value : ''}</span>
          </ReactTooltip>
          <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='redeemBy'>
            <span>{dashboardTooltips.redeemBy ? dashboardTooltips.redeemBy.value : ''}</span>
          </ReactTooltip>
          <ReactTooltip place="right" className='react-tooltip-custom-class' effect="solid" id='from'>
            <span>{dashboardTooltips.from ? dashboardTooltips.from.value : ''}</span>
          </ReactTooltip>
          
          <Row>
            <Col xs="6">
              <div className="new-outreach-limit">Monthly sends {(companyOutreachCount && companyOutreachCount.count) ? companyOutreachCount.count.toLocaleString("en-GB") : 0}/{limit.toLocaleString("en-GB")}</div>
            </Col>

            <Col xs="6">
              <Button className="new-outreach-manage-plan" onClick={this.goToManagePlan} > See plans</Button>
            </Col>
          </Row>

          <Row>
            <Col xs="12">
              <div className="new-outreach-title">New VouchReach</div>
            </Col>

            <Col xs="12">
              <div className="new-outreach-description">Email free vouchers to existing customers to encourage re-engagement.</div>
            </Col>
          </Row>

          {(!error && success) && (
            <Alert color="success" style={{ marginLeft: 15 }}>
              <Row>
                <Col>
                  VouchReach sent! Monitor from the Dashboard and view individual claimed vouchers in Payments.
                </Col>
              </Row>
            </Alert>
          )}
          {(!!error) && <Alert style={{ marginLeft: 15 }} color="danger">{error}</Alert>}

          <Row>
            <Col xs="12">
              <Row className="new-outreach-left-row" style={{ paddingTop: 5 }}>
                <Col xs="6">
                  <Row style={{ paddingBottom: 5 }}>
                    <Col xs="10">
                      <Label className="new-outreach-label" data-tip data-for='name' for="name">
                        <div style={{ whiteSpace: 'nowrap' }}>VouchReach Name</div>
                      </Label>
                      <div className="new-outreach-info-icon">i</div>
                    </Col>
                  </Row>
                </Col>
                <Row>
                </Row>
                <Col xs="12">
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    className="new-outreach-left-input-fullwidth"
                    placeholder="For your own records"
                    value={name || ''}
                    onChange={this.handleChange}
                    style={{ marginLeft: 15, width: 'calc(100% - 15px)' }}
                  />
                </Col>
              </Row>


              <Row className="new-outreach-left-row" style={{ paddingTop: 5 }}>
                <Col xs="6">
                  <Row style={{ paddingBottom: 5 }}>
                    <Col xs="10">
                      <Label className="new-outreach-label" data-tip data-for='recipients' for="recipients">
                        <div style={{ whiteSpace: 'nowrap' }}>Recipients</div>
                      </Label>
                      <div className="new-outreach-info-icon">i</div>
                    </Col>
                  </Row>
                </Col>
                <Row>
                </Row>
                <Col xs="12">
                  <Input
                    type="textarea"
                    name="recipients"
                    id="recipients"
                    className="new-outreach-left-input-fullwidth"
                    placeholder="Paste emails (one per line, remove any spaces)"
                    value={recipients || ''}
                    onChange={this.handleChangeRecipients}
                    style={{ marginLeft: 15, width: 'calc(100% - 15px)', minHeight: 100 }}
                  />
                  <div style={{ textAlign: 'right' }} className="text-length">
                    {`${((emailsList ? emailsList.length : 0).toLocaleString("en-GB"))}/${((limit - ((companyOutreachCount && companyOutreachCount.count) ? companyOutreachCount.count : 0)) > 0 ? (limit - ((companyOutreachCount && companyOutreachCount.count) ? companyOutreachCount.count : 0)) : 0).toLocaleString("en-GB")}`}
                  </div>
                </Col>
              </Row>

              <Row className="new-outreach-left-row" style={{ paddingTop: 5 }}>
                <Col xs="12">
                  <Row style={{ paddingBottom: 5 }}>
                    <Col xs="12">
                      <Label className="new-outreach-label" data-tip data-for='from' for="from">
                        <div style={{ whiteSpace: 'nowrap' }}>From</div>
                      </Label>
                      <div className="new-outreach-info-icon">i</div>

                      <span className="new-outreach-label" style={{ color: "#6c757d", opacity: 0.6, display: 'inline-block' }}><strong>{`${(company && company.name) ? company.name : ''}`}</strong> via no-reply@vouchreach.steppr.com </span>
                    </Col>
                  </Row>
                </Col>
                <Row>
                </Row>
              </Row>

              <Row>
                <Col xs="4" xxl="4">
                  <Row className="new-outreach-right-row">
                    <Col xs="12" style={{ marginLeft: 3 }}>
                      <Row style={{ marginBottom: 5 }}>
                        <Col xs="1" />
                        <Col sm="9" style={{ paddingRight: 0, paddingLeft: 0 }}>
                          <Label className="new-outreach-label new-outreach-label-no-padding" data-tip data-for='value' for="value">
                            <div >Voucher Value</div>
                          </Label>
                          <div className="new-outreach-info-icon">i</div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="11" className="new-outreach-right-input-col" style={{ paddingRight: 0, paddingLeft: 'calc(12px + 8.33333%)' }}>
                          <Input
                            type="text"
                            className="new-outreach-right-input"
                            name="value"
                            id="value"
                            placeholder={`e.g. ${pound}3`}
                            value={value ? formattedNumber(parseInt(value, 10)) : ''}
                            onChange={this.handleChangeValue}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col xs="4" xxl="4">
                  <Row className="new-voucher-right-row  new-voucher-right-row-second">
                    <Col sm="12" style={{ marginBottom: 5 }}>
                      <Label className="new-voucher-label new-outreach-label-no-padding" data-tip data-for='claimBy' for="claimBy">
                        <div>Claim by</div>
                      </Label>
                      <div className="new-outreach-info-icon">i</div>
                    </Col>
                    <Col sm="12" className="new-voucher-right-input-col">
                      <DateTimePicker
                        className="date-picker new-voucher-right-input-start-date"
                        time={false}
                        culture="en"
                        format="Do MMM YYYY"
                        onChange={this.changeClaimByDate}
                        value={claimBy}
                        defaultValue={new Date(Date.now() + (1000 * 60 * 60 * 24 * 30))}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col xs="4" xxl="4">
                  <Row className="new-voucher-right-row  new-voucher-right-row-second">
                    <Col sm="12" style={{ marginBottom: 5 }}>
                      <Label className="new-voucher-label new-outreach-label-no-padding" data-tip data-for='redeemBy' for="redeemBy">
                        <div>Redeem by</div>
                      </Label>
                      <div className="new-outreach-info-icon">i</div>
                    </Col>
                    <Col sm="12" className="new-voucher-right-input-col">
                      <DateTimePicker
                        className="date-picker new-voucher-right-input-start-date"
                        time={false}
                        culture="en"
                        format="Do MMM YYYY"
                        onChange={this.changeRedeemByDate}
                        value={redeemBy}
                        defaultValue={new Date(Date.now() + (1000 * 60 * 60 * 24 * 30))}
                      />
                    </Col>
                  </Row>
                </Col>
                
              </Row>

              <Row className="new-outreach-left-row" style={{ paddingTop: 5 }}>
                <Col xs="6">
                  <Row style={{ paddingBottom: 5 }}>
                    <Col xs="10">
                      <Label className="new-outreach-label" data-tip data-for='subject' for="subject">
                        <div style={{ whiteSpace: 'nowrap' }}>Email Subject</div>
                      </Label>
                      <div className="new-outreach-info-icon">i</div>

                    </Col>
                  </Row>
                </Col>
                <Row>
                </Row>
                <Col xs="12">
                  <Input
                    type="text"
                    name="subject"
                    id="subject"
                    className="new-outreach-left-input-fullwidth"
                    placeholder={`How does a ${pound}3 free voucher from us to you sound?`}
                    value={subject || ''}
                    onChange={this.handleChange}
                    style={{ marginLeft: 15, width: 'calc(100% - 15px)' }}
                  />
                </Col>
              </Row>

              <Row className="new-outreach-left-row" style={{ paddingTop: 5 }}>
                <Col xs="6">
                  <Row style={{ paddingBottom: 5 }}>
                    <Col xs="10">
                      <Label className="new-outreach-label" data-tip data-for='content' for="content">
                        <div style={{ whiteSpace: 'nowrap' }}>Email Content</div>
                      </Label>
                      <div className="new-outreach-info-icon">i</div>

                    </Col>
                  </Row>
                </Col>
                <Row>
                </Row>
                <Col xs="12">
                  <Input
                    type="textarea"
                    name="content"
                    id="content"
                    className="new-outreach-left-input-fullwidth"
                    placeholder={`Write a message to your customers`}
                    value={content || ''}
                    onChange={this.handleChange}
                    style={{ marginLeft: 15, width: 'calc(100% - 15px)' }}
                  />
                </Col>
              </Row>
              {/*
                <Row>
                  <Col>
                  <div style={{ float: 'left', marginBottom: 15, marginTop: 5, fontSize: 14 }}>
                      <Input
                        type="checkbox"
                      name="includeLink"
                      id="includeLink"
                      value={includeLink}
                      onChange={this.handleChangeIncludeLink}
                      style={{ marginLeft: 15 }}
                    />
                    <span style={{ paddingRight: 5, paddingLeft: 11}}>
                      Include campaign link, if live?
                    </span>
                    </div>
                  </Col>
              </Row> */}

              <Row>
                <Col>
                  <div style={{ float: 'left', marginBottom: 15, marginTop: 5, fontSize: 14 }}>
                    <Input
                      type="checkbox"
                      name="permission"
                      id="permission"
                      value={permission}
                      onChange={this.handleChangePermission}
                      style={{ marginLeft: 15 }}
                    />
                    <span style={{ paddingRight: 5, paddingLeft: 11 }}>
                      I have permission to send this email
                    </span>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Button
                    disabled={processing || showNoPermission || (((emailsList ? emailsList.length : 0) + ((companyOutreachCount && companyOutreachCount.count) ? companyOutreachCount.count : 0)) > limit)}
                    style={{ width: 'calc(100% - 10px)', marginLeft: 10, float: 'right', marginBottom: 15, fontWeight: 600, borderRadius: 25 }}
                    color="primary"
                    onClick={this.sendEmails}
                  >
                    {console.log('((emailsList ? emailsList.length : 0) + ((companyOutreachCount && companyOutreachCount.count) ? companyOutreachCount.count : 0))', ((emailsList ? emailsList.length : 0) + ((companyOutreachCount && companyOutreachCount.count) ? companyOutreachCount.count : 0)))}
                    {sendSpinner ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                    ) : (null)}
                    {(((emailsList ? emailsList.length : 0) + ((companyOutreachCount && companyOutreachCount.count) ? companyOutreachCount.count : 0)) > limit) ? (
                    'Not enough sends left'
                    ): ('Send')}
                    
                  </Button>
                </Col>
              </Row>

            </Col>
          </Row>
        </Col>


        {/* <Col
          className="voucher-preview-card"
          style={{
            minWidth: 380,
            maxWidth: 'unset',
            width: 'calc(100% - 420px)',
            height: 'fit-content',
            minHeight: 680,
          }}
        >
          <div className="new-outreach-preview">
          <center>
              <table width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#F6F7FB" style={{ padding: "24px 0" }} >
              <tr>
                <td align="center">
                    <table width="600" border="0" cellspacing="0" cellpadding="0" class="card-container" style={{ backgroundColor: "#ffffff", borderRadius: 16, boxShadow: "0 4px 16px rgba(0,0,0,0.06)", fontFamily: "Arial, sans-serif" }} >
                    <tr>
                      <td style="display:none;
                             font-size:1px;
                             color:#ffffff;
                             line-height:1px;
                             max-height:0;
                             max-width:0;
                             opacity:0;
                             overflow:hidden;">
                          {`Exclusive offer from ${(company && company.name) ? company.name : ''}.`}
                      </td>
                    </tr>
                    <tr>
                        <td align="center" class="card-inner" style={{ padding: "24px 24px 8px 24px" }} >
                        <img src="${logoImageUrl}" alt="Steppr logo" width="56" style={{ display: "block", borderradius: "50%", maxwidth: "100%", height: "auto"}} />
                      </td>
                    </tr>
                    <tr>
                    </tr>
                    <tr>
                        <td align="left" style={{ padding: "0 24px 20px 24px", fontsize: 14, lineheight: 1.6, color: "#4b5563" }} >
                        Hello,<br /><br />
                        ${content}
                      </td>
                    </tr>
                    <tr>
                        <td align="center" style={{ padding: "0 24px 20px 24px" }} >

                        <a href={""} target="_blank"
                          style={{
                            display: "inline-block",
                             backgroundColor: "#22C55E",
                             color: "#ffffff",
                             fontFamily: "Arial, sans-serif",
                             fontSize: 16,
                             fontWeight: 600,
                             lineHeight: 44,
                             textAlign: "center",
                             textDecoration: "none",
                             borderRadius:8,
                             padding: "0 40px",
                             msoHide: "all",
                        }}>
                            {`Claim ${value ? formattedNumber(parseInt(value, 10)) : ''}`}
                        </a>

                      </td>
                    </tr>

                    <tr>
                        <td align="left" style={{ padding: "0 24px 16px 24px", fontSize: 12, lineHeight: 1.5, color: "#6b7280"}}>
                        <center>
                          &#9203;
                          <strong>
                            Exclusive, time-limited offer from
                            <a href="${website}" target="_blank" style={{ color: "#6b7280", textDecoration: "none" }} >
                                {(company && company.name) ? company.name : ''}
                            </a>
                          </strong>
                        </center>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style={{ padding: "0 24px 16px 24px", fontSize:12, lineHeight:1.6, color: "#6b7280" }}>
                        Claim by: ${claimBy}<br />
                        Redeem by: ${redeemBy}<br /> <br />
                        A voucher is created once you click <strong>Claim</strong>.<br />
                        By clicking Claim, you agree to the voucher
                    <strong><a href="${termsUrl}" target="_blank" style={{ color: "#6b7280", textDecoration: "none" }}>T&amp;Cs</a></strong>.
                      </td>
                    </tr>
                    <tr>
                <td align="center" style={{ padding: "0 24px 20px 24px", fontSize:11, lineHeight: 1.6, color: "#9ca3af" }}>
                <a href="https://steppr.com" target="_blank" style={{ color: "#3b82f6", textDecoration: "none" }}>
                          Powered by Steppr
                        </a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </center>
        </div>
        </Col> */}

        <Col
          className="voucher-preview-card"
          style={{
            minWidth: 380,
            maxWidth: 'unset',
            width: 'calc(100% - 420px)',
            height: 'fit-content',
            minHeight: 680,
          }}
        >
          <div className="new-outreach-preview">
            <center>
              <table width="600" border="0" cellSpacing="0" cellPadding="0">
                      <tbody>
                        <tr>
                          <td align="center" class="card-inner" style={{ padding: "24px 24px 8px 24px" }} >
                      <img src={company.logoUrl || defaultLogo} alt="Steppr logo" width="56" style={{ display: "block", borderRadius: "5%", maxWidth: "100%", height: "auto" }} />
                          </td>
                        </tr>
                        <tr>
                          <td align="left" style={{ padding: "8px 24px 8px 24px", fontSize: 22, lineHeight: 1.3, fontWeight: 600, color: "#111827" }} >
                            {}
                          </td>
                        </tr>
                  <tr>
                    <td align="left" style={{ padding: "0 24px 20px 24px", fontsize: 14, lineheight: 1.6, color: "#4b5563" }} >
                      Hello,<br /><br />
                      {content || `How does a ${pound}3 free voucher from us to you sound?`}
                    </td>
                  </tr>
                  <tr>
                    <td align="center" style={{ padding: "0 24px 20px 24px" }} >

                      <a href={""} target="_blank"
                        style={{
                          display: "inline-block",
                          backgroundColor: "#22C55E",
                          color: "#ffffff",
                          fontFamily: "Arial, sans-serif",
                          fontSize: 16,
                          fontWeight: 600,
                          lineHeight: "44px",
                          textAlign: "center",
                          textDecoration: "none",
                          borderRadius: 8,
                          padding: "0 40px",
                          msoHide: "all",
                        }}>
                        {`Claim ${pound}${value ? formattedNumber(parseInt(value, 10)) : '3'} voucher`}
                      </a>

                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ padding: "0 24px 16px 24px", fontSize: 12, lineHeight: 1.5, color: "#6b7280" }}>
                      <center>
                        &#9203;
                        <strong>
                          {`Exclusive, time-limited offer from `}
                          <a href={company.website} target="_blank" style={{ color: "#6b7280", textDecoration: "none" }} >
                            {(company && company.name) ? company.name : ''}
                          </a>
                        </strong>
                      </center>
                    </td>
                  </tr>
                  <tr>
                    <td align="left" style={{ padding: "0 24px 16px 24px", fontSize: 12, lineHeight: 1.6, color: "#6b7280" }}>
                      {`Claim by: ${claimBy.toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })}`}<br />
                      {`Redeem by: ${redeemBy.toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })}`}<br /> <br />
                      {`A voucher is created once you click`} <strong>Claim</strong>.<br />
                      {`By clicking Claim, you agree to the voucher`}
                      <strong><a href="https://steppr.com/app-t-and-c" target="_blank" style={{ color: "#6b7280", textDecoration: "none" }}> T&amp;Cs</a></strong>.
                    </td>
                  </tr>
                  <tr>
                    <td align="center" style={{ padding: "0 24px 20px 24px", fontSize: 11, lineHeight: 1.6, color: "#9ca3af" }}>
                      <a href="https://steppr.com" target="_blank" style={{ color: "#3b82f6", textDecoration: "none" }}>
                        Powered by Steppr
                      </a>
                    </td>
                  </tr>
                      </tbody>
                    </table>
            </center>
            </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  roles: state.users.companiesRoles || {},
  adminsRoles: state.admin.adminsRoles || {},
  dashboardTooltips: state.contentManagement.newOutreachTooltips || {},
  company: state.company.company || {},
  adminViewAsCompany: state.admin.adminViewAsCompany || null,
  vouchers: state.vouchers.vouchers || {},
  branding: state.contentManagement.branding || {},
  companyOutreachCount: state.company.companyOutreachCount || {},
});

const mapDispatchToProps = {
  sendEmails: sendOutreachEmails,
  fetchNewOutreachTooltips: getNewOutreachTooltips,
  updateLastActiveFunc: updateLastActive,
  fetchCompanyOutreachEmailsSentCount: getCompanyOutreachEmailsSentCount,
  createSubscription: createCompanySubscription,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewOutreach));
